import {
  ActionTypes,
  IOrdersInput,
  IGetOrdersRequestReturn,
  IOrdersSuccessInput,
  IGetOrdersSuccessReturn,
} from './types';
import { IOrderDetailed } from '../../../types/orders';

export function getOrdersRequest(input: IOrdersInput): IGetOrdersRequestReturn {
  return {
    type: ActionTypes.getOrdersRequest,
    payload: {
      input,
    },
  };
}

export function getOrdersSuccess(
  input: IOrdersSuccessInput,
): IGetOrdersSuccessReturn {
  return {
    type: ActionTypes.getOrdersSuccess,
    payload: {
      input,
    },
  };
}

export function getOrdersFailure(orders: IOrderDetailed[]): any {
  return {
    type: ActionTypes.getOrdersFailure,
    payload: {
      orders,
    },
  };
}
